import { COUPONS_LOADED } from "actions"

const initState = {
  coupons: []
}

export default function (state = initState, action) {
  switch (action.type) {

    case COUPONS_LOADED: {
      return {
        ...state,
        coupons: action.payload.coupons
      }
    }

    default:
      return state
  }
}